<template>
  <div class="contentDiv">
    <div  class="cover scrollable-div">
      <HeaderContainer :active-index="currentMenuIndex" @menu-select="onMenuSelect"/>

      <div class="search-bar" >
        <div class="search-bar-title" >
          <p class="title" >開獎公告</p>
        </div>
      </div>

      <div class="lastResult">
        <div style="text-align: left;padding: 0px 20px;  border-bottom: 1px solid #cccccc;">
          <div> 第 <span style="color:#d80011 ">{{ lotteryRecordOne.dateNo }}</span> 期開獎號碼 </div>
<!--          <div   class="left-content_info_shuangseqiu">-->

<!--            <img :src="require(`../assets/num${lotteryRecordOne.numberOne}.gif`)">-->
<!--            <img :src="require(`../assets/num${lotteryRecordOne.numberTwo}.gif`)">-->
<!--            <img :src="require(`../assets/num${lotteryRecordOne.numberThree}.gif`)">-->
<!--            <img :src="require(`../assets/num${lotteryRecordOne.numberFour}.gif`)">-->
<!--            <img :src="require(`../assets/num${lotteryRecordOne.numberFive}.gif`)">-->
<!--            <img :src="require(`../assets/num${lotteryRecordOne.numberSix}.gif`)">-->
<!--            <text style="font-size: 20px;line-height: 40px"><b>+</b></text>-->
<!--            <img :src="require(`../assets/num${lotteryRecordOne.numberSeven}.gif`)">-->
<!--          </div>-->
          <div class="" style="text-align: left; padding:0px 10px;">
          <span class="ball ball_margin-top"><span
              :class="['balls-size40', randomColor()]">{{ lotteryRecordOne.numberOne }}</span></span>
            <span class="ball ball_margin-top"><span
                :class="['balls-size40', randomColor()]">{{ lotteryRecordOne.numberTwo }}</span></span>
            <span class="ball ball_margin-top"><span
                :class="['balls-size40', randomColor()]">{{ lotteryRecordOne.numberThree }}</span></span>
            <span class="ball ball_margin-top"><span
                :class="['balls-size40', randomColor()]">{{ lotteryRecordOne.numberFour }}</span></span>
            <span class="ball ball_margin-top"><span
                :class="['balls-size40', randomColor()]">{{ lotteryRecordOne.numberFive }}</span></span>
            <span class="ball ball_margin-top"><span
                :class="['balls-size40', randomColor()]">{{ lotteryRecordOne.numberSix }}</span></span>
            <span class="ball ball_margin-top font-red" style="font-size: 20px; padding: 0px 0px 0px 5px;">+</span>
            <span class="ball ball_margin-top"><span
                :class="['balls-size40', randomColor()]">{{ lotteryRecordOne.numberSeven }}</span></span>
          </div>


          <div STYLE="padding: 10px 0 20px 0 !important;">下期開獎時間：{{ lotteryRecordOne.nextDateTime }}</div>
          <div style="padding-bottom: 20px;">
            <countdown-timer
                v-if="showTimer"
                :seconds="seconds"
                :show-hours="true"
                @time-up="handleTimeUp"
            />
          </div>
        </div>
        <div  v-for="(item, index) in lotteryRecordDataList"  :key="key" class="list_item">
          <div class="list_item_item" style="display: flex">
            <div  class="list_item_name">期號</div>
            <span class="list_item_name_value">第 {{item.dateNo}} 期</span>
          </div>
          <div  class="list_item_item" style="display: flex">
            <div  class="list_item_name">開獎時間</div>
            <span class="list_item_name_value">{{item.winningTime}}</span>
          </div>
          <div  class="list_item_item" style="display: flex">
            <div  class="list_item_name">中獎號碼</div>
            <div>
<!--              <div style="display: flex">-->
<!--                <img :src="require(`../assets/num${item.numberOne}.gif`)" >-->
<!--                <img :src="require(`../assets/num${item.numberTwo}.gif`)" >-->
<!--                <img :src="require(`../assets/num${item.numberThree}.gif`)"  >-->
<!--                <img :src="require(`../assets/num${item.numberFour}.gif`)"  >-->
<!--                <img :src="require(`../assets/num${item.numberFive}.gif`)" >-->
<!--                <img :src="require(`../assets/num${item.numberSix}.gif`)" >-->
<!--                <text style="font-size: 20px;line-height: 26px;    color: #962831;"><b>+</b></text>-->
<!--                <img :src="require(`../assets/num${item.numberSeven}.gif`)">-->
<!--              </div>-->
              <div class="" style="text-align: left; ">
                <span class="ball "><span
              :class="['balls-size30', randomColor()]">{{ item.numberOne }}</span></span>
                <span class="ball "><span
                    :class="['balls-size30', randomColor()]">{{ item.numberTwo }}</span></span>
                <span class="ball "><span
                    :class="['balls-size30', randomColor()]">{{ item.numberThree }}</span></span>
                <span class="ball "><span
                    :class="['balls-size30', randomColor()]">{{ item.numberFour }}</span></span>
                <span class="ball "><span
                    :class="['balls-size30', randomColor()]">{{ item.numberFive }}</span></span>
                <span class="ball "><span
                    :class="['balls-size30', randomColor()]">{{ item.numberSix }}</span></span>
                <span class="ball  font-red" style="font-size: 20px; padding: 0px 0px 0px 5px;">+</span>
                <span class="ball "><span
                    :class="['balls-size30', randomColor()]">{{ item.numberSeven }}</span></span>
              </div>

            </div>
          </div>
        </div>

      </div>



      <footer>
        <div class="foot_con pub_case pure">
          <div class="link_foo">
            <a href="" target="_blank">聯繫我們</a> |
            <a href="" target="_blank">反饋意見</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">免責聲明</a> |
            <a href="" target="_blank">網頁指南</a> |
          </div>
          <div class="copyRight at_on">
            @2011 澳門銀河娛樂有限公司版權所有 不得轉載
          </div>
        </div>
      </footer>
    </div>
  </div>

</template>

<script>
import {lotteryRecordList, lotteryRecordTopOne} from "@/js/api/WebIndexApi";
import router from "@/router";
import HeaderContainer from "@/components/HeaderContainer.vue";
import CountdownTimer from "@/components/CountdownTimer.vue";
import async from "async";

export default {
  name: 'MobileRecordList',
  components: {CountdownTimer, HeaderContainer},
  data() {
    return {
      seconds:0,
      showTimer:false,
      currentMenuIndex: '3', // 根据当前路由设置: 1,
      activeTab: 1,
      searchFrom: {
        dateNo: "",
        winningTime: "",
        currentPage: 1,
        pageSize: 999999
      },
      total:0,
      key:0,
      lotteryRecordDataList:[
        {
          id: 1,
          type: "澳門銀河娛樂",
          dateNo: "2025078",
          winningTime: "2025-06-30",
          numberOne: "11",
          numberTwo: "18",
          numberThree: "22",
          numberFour: "43",
          numberFive: "36",
          numberSix: "28",
          numberSeven: "35",
          totalAmount: "12億69,582,135元",
          weekDay: "星期一",
          onePeopleNum: 0,
          onePeopleMoney: 1.0E7,
          twoPeopleNum: 31,
          twoPeopleMoney: 50000.0,
          threePeopleNum: 1984,
          threePeopleMoney: 200.0,
          fourPeopleNum: 14158,
          fourPeopleMoney: 50.0,
          fivePeopleNum: 148124,
          fivePeopleMoney: 10.0,
          sixPeopleNum: 1574159,
          sixPeopleMoney: 5.0,
          sevenPeopleMoney: 2415887,
          sevenPeopleNum: 1.0,
          createTime: "2025-07-01 16:02:36"
        }
      ],
      lotteryRecordOne:{
        id: 1,
        type: "澳門銀河娛樂",
        nextDateNo: " 2025085",
        nextDateTime: "2025-07-16 21:30:00",
        dateNo: "2025078",
        winningTime: "2025-06-30",
        numberOne: "11",
        numberTwo: "18",
        numberThree: "22",
        numberFour: "43",
        numberFive: "36",
        numberSix: "28",
        numberSeven: "35",
        totalAmount: "12億69,582,135元",
        weekDay: "星期一",
        onePeopleNum: 0,
        onePeopleMoney: 1.0E7,
        twoPeopleNum: 31,
        twoPeopleMoney: 50000.0,
        threePeopleNum: 1984,
        threePeopleMoney: 200.0,
        fourPeopleNum: 14158,
        fourPeopleMoney: 50.0,
        fivePeopleNum: 148124,
        fivePeopleMoney: 10.0,
        sixPeopleNum: 1574159,
        sixPeopleMoney: 5.0,
        sevenPeopleMoney: 2415887,
        sevenPeopleNum: 1.0,
        createTime: "2025-07-01 16:02:36"
      }
    }
  },
  created() {
    this.lotteryRecordTopOne()
    this.lotteryRecordList()
  },
  methods: {
    router() {
      return router
    },
    handleTimeUp() {
      this.lotteryRecordTopOne()
      this.lotteryRecordList()
    },
    randomColor() {
      const colors = ["red", "green", "blue"];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    /*主键函数*/
    onMenuSelect(index, indexPath) {
      console.log('选中菜单:', index, indexPath)
    },
    hrefUrl(url){
      window.location.href =url;
    },
    routerUrl(url){
      this.$router.replace(url);
    },
    handleSizeChange(number) {
      console.log("items per page=" + number)
      this.searchFrom.currentPage=number;
      this.lotteryRecordList();
    },
    handleCurrentChange(number) {
      console.log("current page=" + number)
      this.searchFrom.currentPage=number;
      this.lotteryRecordList();

    },
    getSeconds(nextDateTimeStr){
      // 假设 data.result.nextDateTime 是一个有效的日期时间字符串，如 "2023-12-31T23:59:59"
      const nextDateTime = new Date(nextDateTimeStr);
      const now = new Date();

// 计算时间差（毫秒）并转换为秒
      const diffInSeconds = Math.floor((nextDateTime - now) / 1000);

// 确保结果不为负数
      const remainingSeconds = Math.max(0, diffInSeconds);
      return remainingSeconds;
    },
    lotteryRecordTopOne() {
      var that = this;
       lotteryRecordTopOne({}, function (data) {
        console.log(data)
        that.seconds=that.getSeconds(data.result.nextDateTime)
        that.showTimer=true
        console.log(that.seconds)
        data.result.onePeopleMoney = data.result.onePeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.twoPeopleMoney = data.result.twoPeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.threePeopleMoney = data.result.threePeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.fourPeopleMoney = data.result.fourPeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.fivePeopleMoney = data.result.fivePeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.sixPeopleMoney = data.result.sixPeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        data.result.sevenPeopleMoney = data.result.sevenPeopleMoney.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        that.lotteryRecordOne = data.result;
      })
    },
    lotteryRecordList(){
      var then=this;
      lotteryRecordList(then.searchFrom,function (data){
        console.log(data)
        then.lotteryRecordDataList=data.result.list;
        then.total= data.result.total
        then.key = Math.random()
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
  padding: 0;

  justify-items: center;
}


.contentDiv {
  padding: 0;
  background: rgb(4, 23, 65);
  /*background-image: url("../assets/bgvideo.webp");*/
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  width: 100%;
  height: 100%;
  /*display: flex;*/
  align-items: center; /*定义父元素的元素垂直居中*/
  justify-content: center; /*定义子元素的里的元素水平居中*/
  text-align: center;
}

.search-bar{
  width: 100%;
  line-height: 43px;
  border-top: 1px solid #c4c4c4;
  border-bottom: 1px solid #c4c4c4;
  background-color: #fff;
}
.search-bar-title{
  height: 100%;
  font-size: 18px;
  color: #343434;
  font-weight: 700;
}

.search-bar-title p{
  padding: 0px 10px;
  margin: 0px;
  text-align: left;
}


.lastResult{
  background-color: #fff;
  padding: 5px 0px;
  width: 100%;
}


.left-content_info_shuangseqiu{
  display: flex;
  align-items: center;  /* 垂直居中 */
  justify-content: center;  /* 水平居中 */
  margin-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #cccccc;
}
.left-content_info_shuangseqiu img{
  width: 40px;

}


.list_item{
  background-color: #fff;
  padding: 5px 0px;
  width: 100%;
  border-bottom: 1px solid #cccccc;

}

.list_item_item{
  padding: 5px 10px;
  line-height: 23.5px;
}
.list_item_name{
  width: 70px;
  margin-right: 5px;
  text-align: right;
  font-weight: 700;
  color: #d80011;
}

.list_item_name_value{
  font-size: 14px;
}





.horizontal-nav li {
//margin: 0 15px;
//padding: 8px 16px;
  color: white;
  border-radius: 4px;
}
.el-table .cell {
  box-sizing: border-box;
  line-height: 29px;
  overflow: hidden;
  overflow-wrap: break-word;
  padding: 0 12px;
  text-overflow: ellipsis;
  white-space: normal;
}
.el-table__header .cell{

  background-color: #4c587e !important;
  font-size: 14px;
  line-height: 40px;
  color: #e6c35a !important;
}
.el-pager, .el-pager li {
  align-items: center;
   display: inline-block;

}
table th img, table td img {
  width: 27px;
  margin: 0 2px;
}

.el-table .el-table__cell {
  box-sizing: border-box;
  min-width: 0;
  padding:  0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: var(--el-table-index);
}

.num {
  padding: 54px 0px;
}

.ball {
  display: inline-block;
}

.ball_margin-top {
  margin-top: 40px;
}


.ball .green {
  background-image: url(data:image/png;base64,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);
}

.ball .balls-size50 {
  display: inline-block;
  height: 50px;
  width: 50px;
  text-align: center;
  line-height: 46px;
  background-position: -6px -5px;
  background-size: 60px;
  background-repeat: no-repeat;
  font-size: 24px;
  font-weight: 600;
}

.ball .balls-size40 {
  display: inline-block;
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 36px;
  background-position: 0px 0px;
  background-size: 40px;
  background-repeat: no-repeat;
  font-size: 16px;
  font-weight: 600;
}
.ball .balls-size30 {
  display: inline-block;
  height: 30px;
  width: 30px;
  text-align: center;
  line-height: 26px;
  background-position: 0px -2px;
  background-size: 30px;
  background-repeat: no-repeat;
  font-size: 12px;
  font-weight: 600;
}
.ball .red {
  background-image: url(data:image/png;base64,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);
}

.ball .green {
  background-image: url(data:image/png;base64,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);
}

.ball .blue {
  background-image: url(data:image/png;base64,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);
}

.font-red {
  color: #d80011;
}


@media (max-width: 768px) {
  .kj_tba img {
    width: 26px !important;
    width: 26px  !important;
    max-width: 100%;
    height: auto;
  }

  .kj_tba td:nth-child(4) img {
    margin: 0 2px;
  }
  .link_foo {
    font-size: 4px;
  }

  .copyRight {
    font-size: 4px;
  }
}

ul {
  display: inline-block;
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
}

ul li {
  display: inline-block;
  margin: 0 10px;
}



table th img, table td img {
  width: 27px;
  margin: 0 2px;
}


.pagination-container {
  display: flex;
  justify-content: flex-end; /* 靠右对齐 */
  margin-top: 20px;
}


.pub_title {
  font-size: 38px;
  text-align: center;
  line-height: 1.5;
  margin: 50px 0 25px;
  color: #e0c62b;
}



.scrollable-div {

  overflow-y: auto;       /* 垂直滚动 */
  overflow-x: auto;     /* 隐藏水平滚动 */
  border: 1px solid #ddd;
  border-radius: 4px;
}

footer .foot_con {
  padding: 15px 0;
  color: #4e6692;
  font-size: 12px;
}
.pub_case {
  margin-left: auto;
  margin-right: auto;
}
footer .link_foo {
  float: right;
}
footer .copyRight {
  float: left;
}
footer .foot_con a {
  color: #4e6692;
}
</style>

